import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StrategyEntityItemType } from '../../services/strategyMap';

interface LevelMapListState {
  smaps: StrategyEntityItemType[];
  loading: boolean;
  loadingMore: boolean;
  error: any;
  total: number;
  page: number;
  totalPages: number;
  searchTerm: string;
}

const initialState: LevelMapListState = {
  smaps: [],
  loading: false,
  loadingMore: false,
  error: null,
  total: 0,
  page: 1,
  totalPages: 1,
  searchTerm: '',
};

const strategyMapSlice = createSlice({
  name: 'levelMapList',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setLoadingMore: (state, action: PayloadAction<boolean>) => {
      state.loadingMore = action.payload;
    },
    setSmaps: (state, action: PayloadAction<StrategyEntityItemType[]>) => {
      state.smaps = action.payload;
      state.loading = false;
    },
    appendSmaps: (state, action: PayloadAction<StrategyEntityItemType[]>) => {
      state.smaps = [...state.smaps, ...action.payload];
      state.loadingMore = false;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
      state.loading = false;
      state.loadingMore = false;
    },
    setPagination: (state, action: PayloadAction<{ total: number; page: number; totalPages: number }>) => {
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.totalPages = action.payload.totalPages;
    },
    setSearchTerm: (state, action: PayloadAction<string>) => {
      state.searchTerm = action.payload;
    },
    resetState: () => initialState,
  },
});

export const SMapAction = strategyMapSlice.actions;

export default strategyMapSlice.reducer;
